export const GLOBAL_STATE = 'ModulesOutcome'

export const MODULES_OUTCOME = 'modulesOutcome'
export const MODULES_OUTCOME_LIST = 'modulesOutcomeList'
export const MODULES_OUTCOME_CREATE = 'modulesOutcomeCreate'
